import {useBoardCanvasStore, useSessionStore, useSnapshotStore, useTransformStore} from '@/stores'
import {useSnapshot} from '@/composables/useSnapshot'

// Longest side of a saved board export, keeps the export canvas within what browsers can allocate
const MAX_EXPORT_SIDE = 8192

export const useBoardExport = () => {
  const canvasStore = useBoardCanvasStore()
  const session = useSessionStore()
  const snapshot = useSnapshotStore()
  const transform = useTransformStore()
  const {save} = useSnapshot()

  // The export must stay synchronous up to toDataURL: "Save and close" leaves the board right after the save signal
  const saveBoard = async () => {
    const canvas = canvasStore.canvas
    if (!canvas) return
    const {scale: imageScale} = snapshot.transform
    const {
      top,
      left,
      scale,
      client: {width: clientWidth, height: clientHeight},
    } = session.transform
    const width = clientWidth * scale
    const height = clientHeight * scale
    // Screen pixels per picture pixel: fitted into the client viewport, then the board scale and the zoom. Its inverse
    // keeps the picture at its own resolution. The viewport size of this window said nothing about that, so landscape
    // snapshots were saved smaller than taken.
    const screenScale = (imageScale || 0) * scale * (transform.zoom || 1)
    const nativeMultiplier = screenScale > 0 ? 1 / screenScale : 1
    const multiplier = Math.max(1, Math.min(nativeMultiplier, MAX_EXPORT_SIDE / Math.max(width, height, 1)))
    const data = canvas.toDataURL({
      format: 'jpeg',
      quality: 0.92,
      left,
      top,
      width,
      height,
      multiplier,
    })
    await save(data)
  }

  return {saveBoard}
}
